import { render, staticRenderFns } from "./RoleEditor2.vue?vue&type=template&id=bb2c0468&scoped=true"
import script from "./RoleEditor2.vue?vue&type=script&lang=js"
export * from "./RoleEditor2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2c0468",
  null
  
)

export default component.exports